// src/components/RequestBoxes.js
import React from "react";
import "./RequestBoxes.css";

const RequestBoxes = ({ data }) => {
    if (!data || Object.keys(data).length === 0) return null;

    return (
        <div className="request-boxes-container">
            {Object.entries(data).map(([title, item], idx) => (
                <div
                    key={idx}
                    className="request-box"
                    onClick={() => window.open(item.url, "_blank")}
                    style={{ cursor: "pointer" }}
                >
                    <div className="request-count">{item.count}</div>
                    <div className="request-label">{title}</div>
                </div>
            ))}
        </div>
    );
};

export default RequestBoxes;
